<template>
  <section class="operation-wrapper" :style="{height : clientHeight + 'px'}">
    <section class="operation-con-404">
      <div class="operation-icon-404"></div>
      <p class="operation-title-404">It looks like you are lost :(</p>
      <p class="operation-txt-404">
        The page you are looking for doesn't exist.
      </p>
      <p><router-link class="btn-back" to="/">Go Home</router-link></p>
    </section>
  </section>
</template>
<script>
export default {
  data() {
    return {
      //可视区域高度
      clientHeight: "",
    };
  },
  mounted() {
    // 获取浏览器可视区域高度
    this.clientHeight = `${document.documentElement.clientHeight}` - 104; //document.body.clientWidth;
  },
  methods: {
    
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/404.scss';
</style>
